import React, { Component } from "react";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import WrapperList from "../../../Nano/WrapperList.js";
import CountryCard from "../../../Micro/CountryCard.js";

const StyledCountryBlock = styled(NanoFlex)``;

export class CountryBlock extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <StyledCountryBlock className="rowContainer">
        <WrapperList className="difListWrapper">
          <CountryCard card={this.props.card} />
        </WrapperList>
      </StyledCountryBlock>
    );
  }
}

//Set default props
CountryBlock.defaultProps = {
  card: {},
};

export default CountryBlock;

// --- // Documentation // --- //
/*
  import CountryBlock from './../Partial/CountryBlock.js';
  
  <CountryBlock/>
  */
